import Page from '../classes/Page';

const regularPage = new Page({
  name: 'regular',
  rootElementId: 'js-regular-page',
});

export default regularPage;
